export default __webpack_public_path__ + "static/media/shift-leader-milestone-tracker-header.cd463b8a.png";